import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Landmark, ArrowRight, X } from 'lucide-react';

const STORAGE_KEY = 'cyo_nsw_banner_dismissed_v1';

export const AnnouncementBanner = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const close = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
    setDismissed(true);
  };

  return (
    <div
      className="relative bg-gray-950 text-white"
      data-testid="nsw-announcement-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 py-2.5 pr-8">
          <span className="hidden sm:inline-flex items-center justify-center w-6 h-6 rounded-full bg-emerald-500/20 text-emerald-300 flex-shrink-0">
            <Landmark className="w-3.5 h-3.5" />
          </span>

          <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center gap-x-4 gap-y-1">
            <p className="text-xs sm:text-sm font-semibold leading-snug">
              <span className="text-emerald-300 font-bold">NSW Government:</span>{' '}
              New Home Energy Saver — up to <span className="font-bold">$4,000 off</span> + a{' '}
              <span className="font-bold">$15,000 interest-free loan</span> for solar, batteries &amp; more.
            </p>

            <div className="flex items-center gap-3 flex-shrink-0">
              <Link
                to="/nsw-home-energy-saver"
                data-testid="banner-nsw-link"
                className="inline-flex items-center gap-1 text-xs sm:text-sm font-bold text-white hover:text-emerald-300 transition-colors whitespace-nowrap"
              >
                Check eligibility
                <ArrowRight className="w-3.5 h-3.5" />
              </Link>
              <span className="text-white/20">|</span>
              <Link
                to="/battery-deal"
                data-testid="banner-battery-link"
                className="inline-flex items-center gap-1 text-xs sm:text-sm font-bold text-white hover:text-cyo-orange transition-colors whitespace-nowrap"
              >
                Battery deal
                <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={close}
        data-testid="banner-dismiss-btn"
        aria-label="Dismiss announcement"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
